import React from "react";
import Timeline from "./Timeline";
import Image from "next/image";

interface AccordionProps {
  data: any;
}

const Process: React.FC<AccordionProps> = ({ data }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  return (
    <div className="bg-background-dark text-white relative overflow-hidden">
      <section className="bg-background-white xl:py-25 md:py-[80px] py-[56px] relative">
        <div className="container mx-auto px-4 relative z-10">
          {/* Heading */}
          <h2 className="text-heading-1 font-bold text-center capitalize max-w-[1230px] mx-auto">
            {data?.title ?? ""}
          </h2>
          {data?.short_title && (
            <p className="text-heading-6 font-normal text-center max-w-[914px] mx-auto mt-3">
              {data?.short_title ?? ""}
            </p>
          )}

          <Timeline steps={data?.steps ?? []} />
        </div>

        {/* Background Images */}
        <div
          className="absolute top-0 left-0 right-0 z-0 w-full bg-no-repeat hidden md:block h-full"
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/images/consulting/bg-approch.png')",
          }}
        />

        {/* Mobile image */}
        <section className="author  mt-[150px]">
          <div className="container ">
            <div>
              <div className="w-[100%] lg:w-[95%] ml-auto bg-[linear-gradient(90deg,_#0086E6_40.08%,_#8ABC00_100%)] p-[8px_31px] flex items-center lg:mb-[0px] mb-[167px] ">
                <p className="text-center md:text-left  text-[16px] font-regular w-full text-white">
                  {data?.quote?.short_title ?? ""}
                </p>
              </div>

              <div
                className={` relative z-[1] lg:p-[70px_70px_70px_200px] p-[20px_20px_20px_20px] bg-[url('/images/other-bg-main.png')] bg-no-repeat bg-cover `}
              >
                <div className="mt-[-150px] lg:mt-0 author-img absolute top-0 left-1/2 -translate-x-1/2 lg:top-1/2 lg:left-[-20px] lg:-translate-y-1/2 ">
                  <div className="p-[5px]  inline-block lg:ml-[200px] ">
                    {data?.quote?.profile_image?.data?.attributes?.url && (
                      <Image
                        src={`${baseUrl}${data?.quote?.profile_image?.data?.attributes?.url}`}
                        alt="Author"
                        className="h-[180px] w-[180px] lg:object-cover object-contain"
                        width={180 * 2}
                        height={180 * 2}
                        loading="lazy"
                        quality={100}
                      />
                    )}
                  </div>
                </div>

                <div className="author-info p-[40px_20px] lg:p-[0] lg:pl-[24px] relative z-10">
                  <h6 className="font-bold text-white text-[24px] mb-[24px] lg:text-left text-center">
                    {data?.quote?.title ?? ""}
                  </h6>
                  <h4 className="text-heading-5 font-bold text-white lg:text-left text-center">
                    {data?.quote?.description ?? ""}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Process;
